import firebase from 'firebase'

const defaultHostname = window.location.protocol === 'file:' ? 'localhost' : window.location.hostname;

const emptyTenant = {
    area: 'public',
    tenant: undefined,
    config: {}
};

function getDefaultHostname() {
    let hostname = window.location.protocol === 'file:' || window.location.hostname === 'localhost' 
        ? localStorage.getItem('hostname')
        : window.location.hostname;

    return hostname ? hostname : 'dev.zist.be'; 
}

export const changeHost = function(hostname) {
    if(window.location.protocol === 'file:' || window.location.hostname === 'localhost') {
        localStorage.setItem('hostname', hostname);
        window.location.reload(true);
    } else {
        window.location.href = `https://${hostname}`;
    }
}

export default async function(hostname) {   
    if (!hostname) hostname = getDefaultHostname();

    let cache = window.localStorage.getItem('host-info');
    if(cache){
        try {
            cache = JSON.parse(cache);
            if(cache.hostname === hostname && cache.timestamp > (new Date().getTime() - 600000 /*10m*/))
                return cache.data;
        }
        catch(error) {
            window.localStorage.removeItem('host-info');
        }
    }

    try {
        let ref = `/hostnames/${hostname.replace(/[\.]/g, '_')}`;
        let snapshot = await firebase.database().ref(ref).once('value');
        let value = snapshot.val();
        let data = value !== null ? value : emptyTenant;

        window.localStorage.setItem('host-info', JSON.stringify({
            hostname: hostname,
            timestamp: new Date().getTime(),
            data,
        }));
        
        return data;
    } 
    catch(error) {
        console.error(error);
        return emptyTenant;
    }
}


// WEBPACK FOOTER //
// ./src/router/resolve.js